<template>
  <div v-if="object.tags"
       class="d-flex align-items-center gap-1">
    <template v-for="(t, tind) in object.tags">
      <div
          :title="t.title"
          v-if="tind < 3"
          v-b-tooltip.hover
          class="generic-bubble"
          :style="{ backgroundColor: t.color }"
          :key="`t-${tind}`">
      </div>
    </template>
    <div v-if="object.tags.length > 3"
         :id="`popover-tgt-${object.id}`"
         v-b-tooltip.hover
         class="generic-bubble more-bubble">
      {{ '+' + (object.tags.length - 3) }}
    </div>
    <CustomPopover :target="`popover-tgt-${object.id}`"
                   v-if="object.tags.length > 3"
                   ref="popover"
                   triggers="hover"
                   placement="top"
                   :arrow="false"
                   custom-class="record-popover">
      <div v-for="(t, tind) in object.tags"
           :key="`tagfull-${tind}`"
           class="d-flex align-items-center gap-2">
        <div
            :title="t.title"
            v-b-tooltip.hover
            class="generic-bubble"
            :style="{ backgroundColor: t.color }"
        >
        </div>
        <div>{{ t.title }}</div>
      </div>
    </CustomPopover>
  </div>
</template>

<script>
import CustomPopover from "@/components/parts/calendar/CustomPopover.vue"

export default {
  name: "PatientsDatatableTDTags",
  components: {
    CustomPopover
  },
  props: {
    object: {
      type: Object
    }
  },
}
</script>
